export const getTranslations = async (locale: string) => {
    const { mylounge, header, footer, cart, upcoming, platformJourney, catalog, homepage } =
        await import(
            /* webpackPreload: true */
            /* webpackChunkName: "[request]" */
            `./${locale}.json`
        );

    return {
        ...mylounge,
        ...footer,
        ...header,
        ...cart,
        ...upcoming,
        ...platformJourney,
        ...catalog,
        ...homepage,
        locale: locale.replace('_', '-'),
    };
};
